import { useParams } from 'react-router-dom';
import { createContext } from 'react';

import useGetServiceTemplate from '../hooks/useGetServiceTemplate';

export const GroupServiceContext = createContext(null);

export default function GroupServiceProvider({ children }) {
  const { organisationId, serviceTemplateId } = useParams();

  const {
    data: serviceTemplate,
    isLoading: isServiceTemplateLoading,
    error,
  } = useGetServiceTemplate({ organisationId, serviceTemplateId });

  return (
    <GroupServiceContext.Provider value={{ serviceTemplate, isServiceTemplateLoading, error }}>
      {children}
    </GroupServiceContext.Provider>
  );
}
